<template>
  <div id="contenedor-listado-contrato-superintendentes-mobile">
    <v-card class="mt-4">
      <v-card-text>
        <v-list two-line>
          <template v-for="(superintendente, index) in listadoSuperintendentes">
            <v-list-item :key="`superintendente-${index}`">
              <v-list-item-avatar>
                <avatar
                  tipo="nombre"
                  :size="64"
                  :nombre="superintendente.nombreCompleto"
                >
                </avatar>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>
                  {{ superintendente.nombreCompleto }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  <fecha-humano :fecha="new Date(superintendente.createdAt)">
                  </fecha-humano>
                </v-list-item-subtitle>
                <v-list-item-subtitle class="text--primary">
                  {{ superintendente.datosContacto }}
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn
                v-if="mixValidaScopesActions(3)"
                icon @click="borrarSuperintendente(superintendente)">
                  <v-icon> mdi-delete </v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
            <v-divider
              v-if="index < listadoSuperintendentes.length - 1"
              :key="`divider-${index}`"
            >
            </v-divider>
          </template>
        </v-list>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import eventBus from '@/helpers/eventBus';
import FechaHumano from '@/components/FechaHumano.vue';
import Avatar from '@/components/Avatar.vue';

export default {
  name: 'ContratoSuperintendenteListadoMobile',
  props: {
    listadoSuperintendentes: {
      type: Array,
      required: true,
    },
  },
  components: {
    FechaHumano,
    Avatar,
  },
  data() {
    return {};
  },
  methods: {
    borrarSuperintendente(superintendente) {
      eventBus.$emit('borrar-superintendente-contrato', superintendente);
    },
  },
};
</script>

<style lang="scss">
</style>
